import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { GenericService } from '../../commons/generic.service';
import { environment } from 'environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {
    DadosPessoais,
    GridPessoas,
    ListaDependente,
    ListaSolicitacoes,
    Pendencia,
    PessoaPorCPF,
    PlanoSaude,
    SalvarPessoa, Setor,
    TipoAnexo,
    TipoParentesco,
    TipoPlano,
    TipoSolicitacao,
    TipoStatus
} from "app/model/solicitacaoAuxSaude";
import { ArquivoBlobDTO } from 'app/model/arquivoBlob.dto';
import { ValidaDto } from 'app/model/valida.dto';
import { Enum } from "../../model/enum";

@Injectable()
export class SolicitacaoAuxSaudeService extends GenericService {

    private path = environment.url + 'api/v1';

    constructor(http: HttpClient) {
        super(http);
    }

    getDadosPessoais(): Observable<DadosPessoais> {
        return this.http.get<DadosPessoais>(this.path+'/servidor/dados-basicos')
    }

    getPermitePreencher(): Observable<boolean> {
        return this.http.get<boolean>(this.path+'/form-aux-saude/permite-preencher')
    }

    getPlanoSaude(nome:string,tipoPlano:number): Observable<PlanoSaude[]> {
        return this.http.get<PlanoSaude[]>(this.path+`/tipos-planos-saude?nome=${nome}&tipoPlano=${tipoPlano}`)
    }

    getTipoSolicitacao(): Observable<TipoSolicitacao[]> {
        return this.http.get<TipoSolicitacao[]>(this.path+'/form-aux-saude/tipo-solicitacoes')
    }

    getTipoPlanos(): Observable<TipoPlano[]> {
        return this.http.get<TipoPlano[]>(this.path+'/form-aux-saude/tipo-planos')
    }

    getTipoParentesco(): Observable<TipoParentesco[]> {
        return this.http.get<TipoParentesco[]>(this.path+'/tipo-parentesco/form-aux-saude')
    }

    getTipoCapacidade(): Observable<Enum[]> {
        return this.http.get<Enum[]>(this.path+'/form-aux-saude/listar/tipo-capacidade-dependente')
    }

    getCpfDependente(cpf:number): Observable<PessoaPorCPF[]> {
        return this.http.get<PessoaPorCPF[]>(this.path+`/dependentes/busca-por-cpf?cpf=${cpf}`)
    }

    getTipoAnexo(dados:any): Observable<TipoAnexo[]> {
        return this.http.get<TipoAnexo[]>(this.path+`/form-aux-saude/tipos-anexos?tipoParentesco=${dados.tipoParentesco}&dataNascimento=${dados.dataNascimento}&tipoPlano=${dados.tipoPlano}&cpf=${dados.cpf}`)
    }

    setPessoa(data:SalvarPessoa): Observable<any> {
        return this.http.post(this.path + "/form-aux-saude/solicitar", data);
    }

    getGrid(): Observable<GridPessoas> {
        return this.http.get<GridPessoas>(this.path+`/form-aux-saude/lista-rascunhos`)
    }

    deletarPessoa(data): Observable<any> {
        return this.http.delete<any>(this.path + `/form-aux-saude/excluir-item-rascunho?isDependente=${data.isDependente}&id=${data.id}`);
    }

    getListaAnexos(data): Observable<ListaDependente[]> {
        return this.http.get<ListaDependente[]>(this.path + `/form-aux-saude-anexos/lista?isDependente=${data.isDependente}&id=${data.id}`)
    }

    getAnexo(data) {
        const options = {
          responseType: 'blob' as 'json'
        };
        return this.http.get<ArquivoBlobDTO>(this.path + `/form-aux-saude-anexos/visualizar-arquivo?id=${data.id}&isDependente=${data.isDependente}`, options)
    }

    deletarAnexo(id): Observable<any> {
        return this.http.delete<any>(this.path + `/form-aux-saude-anexos/delete?id=${id}`);
    }

    uploadAnexo(formData: FormData): Observable<any> {
        return this.patchMethodFile(this.path + '/form-aux-saude-anexos/upload', formData);
    }

    submit(solicitacaoId:number): Observable<any> {
        return this.http.put<any>(this.path + `/form-aux-saude/enviar-solicitacao/${solicitacaoId}`,null);
    }

    getListaStatus(): Observable<TipoStatus[]> {
        return this.http.get<TipoStatus[]>(this.path + `/form-aux-saude/listar/status`)
    }

    getListaSetor(): Observable<Setor[]> {
        return this.http.get<Setor[]>(this.path + `/form-aux-saude/gestao/listar/setor`)
    }

    getListaSolicitacoes(filter): Observable<ListaSolicitacoes> {
        const queryParams = this.parseGetParams(filter);
        return this.http.get<ListaSolicitacoes>(this.path + '/form-aux-saude/listar'+ (queryParams ? `?${queryParams}` : ''))
    }

    getListaSolicitacoesCPREV(filter): Observable<ListaSolicitacoes> {
        const queryParams = this.parseGetParams(filter);
        return this.http.get<ListaSolicitacoes>(this.path + '/form-aux-saude/gestao/listar'+ (queryParams ? `?${queryParams}` : ''))
    }

    getVisualizarSolicitacao(id:number): Observable<any> {
        return this.http.get<any>(this.path + `/form-aux-saude/gestao/visualizar/${id}`)
    }

    getVisualizarListaAnexosSolicitacao(id:number,dependente:boolean): Observable<any> {
        return this.http.get<any>(this.path + `/form-aux-saude-anexos/gestao/lista?id=${id}&isDependente=${dependente}`)
    }

    getListarAdamento(id:number): Observable<any> {
        return this.http.get<any>(this.path + `/form-aux-saude/listar/andamentos/${id}`)
    }

    getAnexoSolicitacao(data) {
        const options = {
          responseType: 'blob' as 'json'
        };
        return this.http.get<ArquivoBlobDTO>(this.path + `/form-aux-saude-anexos/gestao/visualizar-arquivo?id=${data.id}`, options)
    }

    getMotivoRejeicao(): Observable<any[]> {
        return this.http.get<any[]>(this.path + `/form-aux-saude/listar/status`)
    }

    getEditarVisualizar(id:number): Observable<any> {
        return this.http.get<any>(this.path + `/form-aux-saude/visualizar/${id}`)
    }

    getTipoRejeicao(): Observable<any[]> {
        return this.http.get<any[]>(this.path + `/form-aux-saude/gestao/tipos-motivos-rejeicao`)
    }

    salvarAvalicao(data, path: string = ""): Observable<any> {
        return this.http.post(`${this.path}/form-aux-saude/gestao/avaliar${path}`  , data);
    }

    getMotivoRecusa(id: number): Observable<Pendencia> {
        return this.http.get<any>(this.path + `/form-aux-saude/motivo-recusa/${id}`)
    }

    validaSolicitacaoInativo(data): Observable<ValidaDto> {
        return this.http.post<ValidaDto>(this.path + `/form-aux-saude/verificar-inativo`, data);
    }
}
